export default __webpack_public_path__ + "static/media/1.eb0b111f.png";